import { render, staticRenderFns } from "./ServicoAtivo.vue?vue&type=template&id=50426294&scoped=true&"
import script from "./ServicoAtivo.vue?vue&type=script&lang=js&"
export * from "./ServicoAtivo.vue?vue&type=script&lang=js&"
import style0 from "./ServicoAtivo.vue?vue&type=style&index=0&id=50426294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50426294",
  null
  
)

export default component.exports